import { useQueryClient } from "@tanstack/react-query";

import { actionType } from "./constants";
import {
  addUserReward,
  deductUserReward,
  updateUserRedemption,
  updateUserReward,
} from "../../../api/customer";

const useSubmit = ({
  omneId,
  activityTypeId,
  userRedemptionId,
  userRewardId,
  points,
  remark,
  mode,
  permission_Token,
  rewardId,
  resetData,
  handleClose,
  setDisableSubmit,
}) => {
  const handleAfterSubmit = () => {
    resetData();
    handleClose();
  };

  const queryClient = useQueryClient();

  // for Refund && Add Points function
  const handleAddUserReward = () => {
    const data = {
      userId: omneId,
      activityTypeId,
      numberOfPoint: Number(points),
      remark,
      permission_Token,
    };
    addUserReward(data)
      .then(res => {
        handleAfterSubmit();
        const data = JSON.parse(res.data);
        data.isSuccess && queryClient.invalidateQueries(["redemptionHistory"]);
        alert(data.message);
      })
      .catch(err => {
        handleAfterSubmit();
        alert(JSON.stringify(err.data.errors));
      });
  };
  // for Edit(Reward) function
  const handleUpdateUserReward = () => {
    const data = {
      UserRewardId: userRewardId,
      UserId: omneId,
      RewardPoints: Number(points),
      permission_Token,
    };
    updateUserReward(data)
      .then(res => {
        handleAfterSubmit();
        queryClient.invalidateQueries(["redemptionHistory"]);
        alert(res.data.message);
      })
      .catch(err => {
        handleAfterSubmit();
        alert(err.data.message);
      });
  };
  // for Edit(Redemption) function
  const handleUpdateUserRedemption = () => {
    const data = {
      UserRedemptionId: userRedemptionId,
      UserId: omneId,
      RedemptionPoints: Number(points),
      permission_Token,
    };
    updateUserRedemption(data)
      .then(res => {
        handleAfterSubmit();
        queryClient.invalidateQueries(["redemptionHistory"]);
        alert(res.data.message);
      })
      .catch(err => {
        handleAfterSubmit();
        alert(err.data.message);
      });
  };
  // for Deduct Points function
  const handleDeductUserReward = () => {
    const data = {
      userId: omneId,
      rewardId,
      numberOfPoint: Number(points),
      permission_Token,
      remark,
    };
    deductUserReward(data)
      .then(res => {
        handleAfterSubmit();
        const data = JSON.parse(res.data);
        data.isSuccess && queryClient.invalidateQueries(["redemptionHistory"]);
        alert(data.message);
      })
      .catch(err => {
        handleAfterSubmit();
        alert(JSON.stringify(err.data.errors));
      });
  };

  const handleSubmitOnAddPointsDialog = () => {
    setDisableSubmit(true);
    switch (mode) {
      case actionType.ADD:
      case actionType.REFUND:
        handleAddUserReward();
        break;
      case actionType.EDIT:
        handleUpdateUserReward();
        break;
    }
  };
  const handleSubmitOnDeductPointsDialog = () => {
    setDisableSubmit(true);
    if (mode === actionType.DEDUCT) {
      handleDeductUserReward();
    } else if (mode === actionType.EDIT) {
      handleUpdateUserRedemption();
    }
  };

  return { handleSubmitOnAddPointsDialog, handleSubmitOnDeductPointsDialog };
};

export default useSubmit;
